var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"pull-right mr-2"},[_c('a',{attrs:{"href":"#"},on:{"click":_vm.toggle}},[_c('i',{staticClass:"fa-star star",class:_vm.active?'fas':'far'})])])
}
var staticRenderFns = []

export { render, staticRenderFns }